
import AssetsInfo from '@/components/assets-info/assets-info.vue';
import { mapGetters } from 'vuex';
import Service from '../service.js';
import Service1 from '@/service/index.js';
export default {
  components: {
    AssetsInfo
  },
  data() {
    return {
      massifTypeArr: [],
      projectTypeArr: [],
      Assetslist: [],
      detail: {},
      assetsInfo: [],
      projectInfo: null,
      subTypeObj: {},
      assetsStatusArr: [
        {code: 0, value: '可用'},
        {code: 1, value: '审核中'},
        {code: 2, value: '交易中'},
        {code: 3, value: '已流转'},
        {code: 4, value: '已到期'}
      ] // 资产状态
    };
  },

  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created () {
    this.getDictList();
    this.query = this.$route.query;
    this.getDetail();
    Service1.getSelectList('PROJECT_TYPE').then((res) => {
      if (res.code === '0') {
        this.projectTypeArr = res.data;
        this.projectTypeArr.map(item => {
          item.list.map(subItem => {
            this.subTypeObj[`${item.code}-${subItem.code}`] = subItem.value;
          });
        });
      }
    });
  },
  methods: {
    getDictList () {
      const obj = {
        MASSIF_TYPE: 'massifType'
      };
      Object.keys(obj).forEach((key) => {
        Service1.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this.massifTypeArr = res.data;
          }
        });
      });
    },
    getDetail(){
      Service.getAssetsInfo(this.query).then(res => {
        if (res && res.code === '0') {
          this.detail = res.data;
          this.projectTypeArr.forEach(res => {
            if(parseInt(res.code) === this.detail.projectType) {
              this.Assetslist =  res.list;
            }
          });
          const assetsInfo  = JSON.parse(res.data.assetsInfo);
          if(assetsInfo instanceof Array) {
            this.assetsInfo = JSON.parse(res.data.assetsInfo);
          }else {
            this.assetsInfo.push(JSON.parse(res.data.assetsInfo));
          }
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });

    },
    previousStep () {
      this.$router.back();
    }
  }
};
